import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { Button, Modal } from 'react-bootstrap'

interface ModalConfirmarBorrarSeleccionIndividualProps {
    show: boolean
    setShow: (show: boolean) => void
    quitarSeleccionado: () => void
}

const ModalConfirmarBorrarSeleccionIndividual = ({
    show,
    setShow,
    quitarSeleccionado
}: ModalConfirmarBorrarSeleccionIndividualProps) => {
    return (
        <Modal show={show} centered style={{ backgroundColor: 'rgba(1,1,1,0.5)' }}>
            <Modal.Header closeButton={false} className="modal-header-danger" >
                <Modal.Title style={{ color: 'white', fontWeight: 'bold' }}>Confirmar</Modal.Title>
            </Modal.Header>

            <Modal.Body style={{display:'flex', flexDirection:'column', alignItems: 'center'}}>
                <FontAwesomeIcon icon={faExclamationTriangle} color='red' size='3x' />
                <p style={{ fontSize: 15, fontWeight: 'bold', textAlign: 'center', marginTop: 10 }}>¿Está seguro de que desea quitar el despacho?</p>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="danger" onClick={() => {
                    quitarSeleccionado()
                    setShow(false)
                }}>
                    Aceptar
                </Button>
                <Button variant="secondary" onClick={() => setShow(false)}>
                    Cerrar
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default ModalConfirmarBorrarSeleccionIndividual
